import { render } from "./chatWindowMinimized.vue?vue&type=template&id=0e38fced&scoped=true"
import script from "./chatWindowMinimized.vue?vue&type=script&lang=js"
export * from "./chatWindowMinimized.vue?vue&type=script&lang=js"

import "./chatWindowMinimized.vue?vue&type=style&index=0&id=0e38fced&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e38fced"]])

export default __exports__